import React from "react";
import { QueryRenderer, createFragmentContainer, graphql } from "react-relay";
import environment from "../AuthEnv";
import PostNoteView from "./PostNoteView";
import { ITEMS_PER_PAGE } from "../constants";
import { ROOT_ID } from "relay-runtime";
import Spinner from "../Spinner";

const selectedBookmarksQuery = graphql`
	query PostNoteViewContainerQuery(
		$orderBy: [String]
		$count: Int!
		$after: String
		$filterTerms: [String]
	) {
		...PostNoteView_home_Feeds
	}
`;

function PostNoteViewContainer(props) {
	const {
		isParent,
		selectedNodeId,
		filterTerms,
		selectedPostId
	} = props.settings;

	let user = props.user;
	let settings = props.settings;

	let orderFields = ["-created"];
	return (
		<QueryRenderer
			environment={environment}
			query={selectedBookmarksQuery}
			variables={{
				orderBy: orderFields,
				count: ITEMS_PER_PAGE,
				filterTerms: filterTerms,
			}}
			render={({ error, props }) => {
				if (error) {
					return <div>Error!</div>;
				}
				if (!props) {
					return (
						<div>
							<Spinner isLoading={true} />
						</div>
					);
				}
				return (
					<div>
						<PostNoteView user={user} settings={settings} home_Feeds={props} />
					</div>
				);
			}}
		/>
	);
}

export default PostNoteViewContainer; 
